<p-checkbox binary="true" [formControl]="ngControl.control" [label]="label"></p-checkbox>
<rb-error-marker [control]="ngControl.control"></rb-error-marker>
